"use client";

import { useState } from "react";
import { Plus } from "lucide-react";

interface FaqItem {
  question: string;
  answer: string;
}

export default function PricingFaq({ faqs }: { faqs: FaqItem[] }) {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <div className="flex flex-col gap-3">
      {faqs.map((faq, i) => {
        const isOpen = openIdx === i;
        return (
          <div
            key={i}
            className={`overflow-hidden rounded-xl border transition-colors duration-200 ${
              isOpen ? "border-border-medium bg-bg-surface" : "border-border-subtle bg-bg-card"
            }`}
          >
            <button
              onClick={() => setOpenIdx(isOpen ? null : i)}
              aria-expanded={isOpen}
              className="focus-ring flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
            >
              <span className={`text-base font-medium transition-colors ${isOpen ? "text-white" : "text-text-secondary"}`}>
                {faq.question}
              </span>
              <Plus
                size={18}
                className={`shrink-0 text-text-muted transition-transform duration-200 ${isOpen ? "rotate-45" : ""}`}
              />
            </button>
            <div
              className="grid transition-all duration-300 ease-out"
              style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}
            >
              <div className="overflow-hidden">
                <p className="px-6 pb-5 text-base leading-relaxed text-text-secondary">
                  {faq.answer}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
